
function toggleVideo(videoId, containerId) {
  const video = document.getElementById(videoId);
  const container = document.getElementById(containerId);
  const playIcon = container.querySelector('.a-plus-play-icon');
  const pauseIcon = container.querySelector('.a-plus-pause-icon');
  
  if (video.paused) {
    video.play();
    container.classList.add('playing');
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'block';
  } else {
    video.pause();
    container.classList.remove('playing');
    playIcon.style.display = 'block';
    pauseIcon.style.display = 'none';
  }
}

// Reset to play icon when video ends
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('video');
  videos.forEach(function(video) {
    video.addEventListener('ended', function() {
      const container = video.closest('.a-plus-video-container');
      const playIcon = container.querySelector('.a-plus-play-icon');
      const pauseIcon = container.querySelector('.a-plus-pause-icon');
      container.classList.remove('playing');
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".accordion-item");

  items.forEach((item) => {
    const toggle = item.querySelector(".accordion-toggle");
    const content = item.querySelector(".accordion-content");

    toggle.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      items.forEach((i) => {
        i.classList.remove("active");
        i.querySelector(".accordion-content").style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add("active");
        const inner = item.querySelector(".accordion-inner");
        content.style.maxHeight = inner.scrollHeight + "px";
      }
    });
  });
});

   // Remove lazysizes classes from all images
document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        img.classList.remove('ls-is-cached', 'lazyloaded', 'lazyload', 'entered', 'error');
    });
});